import { array } from 'fp-ts/lib/Array'

export interface Action<K extends string> {
  readonly type: K
}
const actionType = <A extends Action<any>>(a: A): (typeof a)['type'] => a.type

export type ActionType<A extends Action<any>> = A['type']

export interface AnyAction extends Action<'any'> {}

export type Reducer<A extends Action<any>, S> = (a: A) => (s: S) => S

export const createReducer = <S, A extends Action<any>>(initialState: S, handlers: Handlers<S, A>): Reducer<A, S> => (
  action: A
) => (state = initialState) => {
  const type = actionType(action)
  return handlers.hasOwnProperty(type) && type !== 'any' ? getHandler(handlers, action)(action)(state) : state
}

export type FilterAction<A, K> = Extract<A, { type: K }>

export type Handlers<S, A extends Action<any>> = { [T in ActionType<A>]: (a: A) => (s: S) => S }
const getHandler = <S, A extends Action<any>>(handlers: Handlers<S, A>, action: A): ((a: A) => (s: S) => S) =>
  handlers[actionType(action)]

type ReducersMap<A extends Action<any>, S> = { [K in keyof S]: Reducer<A, S[K]> }

export const combineReducers = <S, A extends Action<any>>(
  o: ReducersMap<A, S>,
  initialState: S
): ((a: A) => (s: S | undefined) => S) => a => (s = initialState): S =>
  array.reduce(Object.keys(o) as Array<keyof S>, initialState, (acc: S, key: keyof S) => {
    if (key === 'router') {
      return acc
    }
    return Object.assign({}, acc, {
      [key]: o[key](a)(s[key])
    })
  })

// export const isGen = <A extends Action<any>>() => <
//   T extends ActionType<A>,
//   B extends FilterAction<A, T>
// >(
//   types: T[] | T
// ) => (action: A): action is B =>
//   Array.isArray(types)
//     ? types.indexOf(action.type) !== -1
//     : action.type === types

export const NO_ACTION = '[Nothing] No Action'
export type NO_ACTION = typeof NO_ACTION
export interface NoAction extends Action<NO_ACTION> {}
export const noAction: NoAction = {
  type: NO_ACTION
}



// WEBPACK FOOTER //
// ./src/framework/redux.ts